import { c as _c } from "react/compiler-runtime";
import { useDate, useDestination, useHistory, usePassengerCount, useSubmit, useValidation } from "@website/accommodation-ui/hotel-search/hotel-search-panel/hooks";
import { HotelSearchPanelPropertiesType } from "@website/accommodation-ui/hotel-search/hotel-search-panel/hotel-search-panel.types";
import { MaterialIcon } from "@website/icons/material";
import { AutoComplete } from "@website/ui/auto-complete";
import { Button } from "@website/ui/button";
import { Datepicker } from "@website/ui/datepicker";
import isEmpty from "lodash-es/isEmpty";
import { FC, useEffect } from "react";
export const HotelSearchPanel: FC<HotelSearchPanelPropertiesType> = properties => {
  const $ = _c(86);
  const {
    size,
    searchType,
    initialCityData,
    onClose,
    passengerCountInitialValues,
    datePickerInitialValues,
    handleSearchSubmit,
    searchSuggestion,
    searchAutocompleteFetcher,
    landingSearch,
    source,
    hasBorder,
    hasWhiteBg,
    hasPlaceHolder,
    searchBtnClassName,
    destinationPlaceholder,
    hasBtnClose: t0,
    isFloatCloseButton: t1,
    hasTitle: t2,
    requireDates: t3,
    submitOnDestinationSelect
  } = properties;
  const hasButtonClose = t0 === undefined ? true : t0;
  const isFloatCloseButton = t1 === undefined ? true : t1;
  const hasTitle = t2 === undefined ? true : t2;
  const requireDates = t3 === undefined ? true : t3;
  const {
    passengerCount
  } = usePassengerCount(passengerCountInitialValues);
  const t4 = initialCityData?.title;
  let t5;
  if ($[0] !== destinationPlaceholder || $[1] !== hasPlaceHolder || $[2] !== searchAutocompleteFetcher || $[3] !== searchSuggestion || $[4] !== t4) {
    t5 = {
      cityTitleInitialValues: t4,
      searchSuggestion,
      searchAutocompleteFetcher,
      hasPlaceHolder,
      destinationPlaceholder
    };
    $[0] = destinationPlaceholder;
    $[1] = hasPlaceHolder;
    $[2] = searchAutocompleteFetcher;
    $[3] = searchSuggestion;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const {
    selectedDestinationItem,
    selectedDestinationText,
    destinationQuery,
    onChangeDestination,
    onChangeDestinationQuery,
    onSelectDestination,
    destinationLoading,
    destinationListNormalized,
    DestinationNoResult
  } = useDestination(t5);
  const {
    date,
    onChangeDate
  } = useDate(datePickerInitialValues);
  const {
    historyListNormalized,
    addToHistory,
    onSelectHistory
  } = useHistory(onChangeDestination, submitOnDestinationSelect);
  let t6;
  if ($[6] !== date || $[7] !== initialCityData || $[8] !== requireDates || $[9] !== searchType || $[10] !== selectedDestinationItem) {
    t6 = {
      selectedDestinationItem,
      date,
      initialDestinationItem: initialCityData,
      requireDates,
      searchType
    };
    $[6] = date;
    $[7] = initialCityData;
    $[8] = requireDates;
    $[9] = searchType;
    $[10] = selectedDestinationItem;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const {
    destinationError,
    dateError,
    submitValidationCheck
  } = useValidation(t6);
  const {
    onSubmitClick,
    submitLoading
  } = useSubmit(selectedDestinationItem, date, passengerCount, addToHistory, submitValidationCheck, handleSearchSubmit, initialCityData, requireDates);
  let t7;
  let t8;
  if ($[12] !== onSubmitClick || $[13] !== selectedDestinationItem || $[14] !== submitOnDestinationSelect) {
    t7 = () => {
      if (submitOnDestinationSelect && selectedDestinationItem) {
        onSubmitClick();
      }
    };
    t8 = [onSubmitClick, selectedDestinationItem, submitOnDestinationSelect];
    $[12] = onSubmitClick;
    $[13] = selectedDestinationItem;
    $[14] = submitOnDestinationSelect;
    $[15] = t7;
    $[16] = t8;
  } else {
    t7 = $[15];
    t8 = $[16];
  }
  useEffect(t7, t8);
  const t9 = `${searchType === "hotel" ? "gap-8" : "gap-6"} ${source === "nowrouzLanding" && hasBorder && "border-primary border"} ${hasWhiteBg && "bg-white"} ${source === "nowrouzLanding" ? "shadow-6 h-auto rounded-[16px] p-3 pr-2" : "h-full lg:h-auto"} relative mb-4 flex flex-col lg:mb-0`;
  let t10;
  if ($[17] !== hasTitle || $[18] !== landingSearch || $[19] !== searchType) {
    t10 = !landingSearch && <h3 className={`${hasTitle ? "block" : "hidden"} text-headline-6 lg:hidden`}>{searchType === "hotel" ? "\u062A\u0639\u06CC\u06CC\u0646 \u0628\u0627\u0632\u0647 \u0627\u0642\u0627\u0645\u062A" : "\u0647\u062A\u0644"}</h3>;
    $[17] = hasTitle;
    $[18] = landingSearch;
    $[19] = searchType;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  const t11 = `flex flex-col gap-4 xl:flex-row ${searchType === "hotel" ? "w-full" : ""}`;
  const t12 = `flex gap-4 lg:flex-row ${searchType === "city" ? "flex-1" : "w-full lg:items-center"} ${source === "nowrouzLanding" ? "flex-row flex-wrap" : "flex-col"} `;
  let t13;
  if ($[21] !== DestinationNoResult || $[22] !== destinationError || $[23] !== destinationListNormalized || $[24] !== destinationLoading || $[25] !== destinationPlaceholder || $[26] !== destinationQuery || $[27] !== historyListNormalized || $[28] !== onChangeDestinationQuery || $[29] !== onSelectDestination || $[30] !== onSelectHistory || $[31] !== searchType || $[32] !== selectedDestinationText || $[33] !== size || $[34] !== source) {
    t13 = searchType !== "hotel" && <div className={`${source === "nowrouzLanding" ? "flex-[1.2]" : "flex-[3]"} ${searchType === "category" ? "pointer-events-none opacity-60" : ""}`}><AutoComplete disabled={!isEmpty(destinationPlaceholder)} error={destinationError} fullWidth={true} hasDropdownIcon={source === "nowrouzLanding"} hideBorder={source === "nowrouzLanding"} hideStartIcon={source === "nowrouzLanding"} inputClassName={source === "nowrouzLanding" ? "placeholder:text-black pt-1 " : undefined} labelClassName={source === "nowrouzLanding" ? "pt-4" : ""} parts={[{
        label: source === "nowrouzLanding" ? "\u0645\u0642\u0635\u062F" : "\u0634\u0647\u0631 \u06CC\u0627 \u0647\u062A\u0644 \u0645\u0642\u0635\u062F",
        list: DestinationNoResult ? [] : destinationListNormalized,
        historyList: !DestinationNoResult && !destinationLoading ? historyListNormalized : [],
        historyTitle: "\u062C\u0633\u062A\u062C\u0648 \u0647\u0627\u06CC \u0627\u062E\u06CC\u0631",
        text: selectedDestinationText || "",
        onSelect: onSelectDestination,
        onSelectHistory,
        onChangeQuery: onChangeDestinationQuery,
        query: destinationQuery,
        loading: destinationLoading,
        NoResult: DestinationNoResult
      }]} size={size} /></div>;
    $[21] = DestinationNoResult;
    $[22] = destinationError;
    $[23] = destinationListNormalized;
    $[24] = destinationLoading;
    $[25] = destinationPlaceholder;
    $[26] = destinationQuery;
    $[27] = historyListNormalized;
    $[28] = onChangeDestinationQuery;
    $[29] = onSelectDestination;
    $[30] = onSelectHistory;
    $[31] = searchType;
    $[32] = selectedDestinationText;
    $[33] = size;
    $[34] = source;
    $[35] = t13;
  } else {
    t13 = $[35];
  }
  const t14 = `${searchType === "hotel" ? "flex-auto lg:max-w-[312px]" : "flex-[2]"}`;
  const t15 = dateError.length > 0;
  const t16 = searchType === "hotel" ? "0px" : "-16px";
  const t17 = searchType === "hotel" ? "42px" : "-16px";
  const t18 = source === "nowrouzLanding";
  const t19 = source === "nowrouzLanding";
  const t20 = source === "nowrouzLanding" ? "placeholder:text-black" : undefined;
  const t21 = source === "nowrouzLanding" ? "pt-4" : "";
  let t22;
  if ($[36] !== source) {
    t22 = source === "nowrouzLanding" ? ["top", "bottom", "start", "end"] : undefined;
    $[36] = source;
    $[37] = t22;
  } else {
    t22 = $[37];
  }
  const t23 = searchType === "hotel" ? "start" : "end";
  const t24 = searchType === "hotel" ? "dense" : "default";
  let t25;
  if ($[38] !== date) {
    t25 = date ?? [];
    $[38] = date;
    $[39] = t25;
  } else {
    t25 = $[39];
  }
  let t26;
  if ($[40] !== dateError || $[41] !== onChangeDate || $[42] !== onSubmitClick || $[43] !== t15 || $[44] !== t16 || $[45] !== t17 || $[46] !== t18 || $[47] !== t19 || $[48] !== t20 || $[49] !== t21 || $[50] !== t22 || $[51] !== t23 || $[52] !== t24 || $[53] !== t25) {
    t26 = <Datepicker error={t15} fromTitle={"\u062A\u0627\u0631\u06CC\u062E \u0648\u0631\u0648\u062F"} fullWidth={true} gapHorizontal={t16} gapVertical={t17} hasDropdownIcon={t18} helperText={dateError} hideMiddleLine={t19} inputClassName={t20} labelClassName={t21} mode="range" noBorder={t22} onChange={onChangeDate} ctaAcceptClick={onSubmitClick} position={t23} size={t24} toTitle={"\u062A\u0627\u0631\u06CC\u062E \u062E\u0631\u0648\u062C"} value={t25} />;
    $[40] = dateError;
    $[41] = onChangeDate;
    $[42] = onSubmitClick;
    $[43] = t15;
    $[44] = t16;
    $[45] = t17;
    $[46] = t18;
    $[47] = t19;
    $[48] = t20;
    $[49] = t21;
    $[50] = t22;
    $[51] = t23;
    $[52] = t24;
    $[53] = t25;
    $[54] = t26;
  } else {
    t26 = $[54];
  }
  let t27;
  if ($[55] !== t14 || $[56] !== t26) {
    t27 = <div className={t14}>{t26}</div>;
    $[55] = t14;
    $[56] = t26;
    $[57] = t27;
  } else {
    t27 = $[57];
  }
  const t28 = `w-full ${searchBtnClassName}${source === "nowrouzLanding" ? "relative md:w-[134px]" : "absolute bottom-0 lg:relative lg:w-[134px]"}`;
  const t29 = searchType === "hotel" ? "secondary" : "primary";
  const t30 = searchType === "hotel" ? "medium" : "x-large";
  const t31 = landingSearch ? "\u062C\u0633\u062A\u062C\u0648" : "\u0628\u0631\u0648\u0632\u0631\u0633\u0627\u0646\u06CC \u062C\u0633\u062A\u062C\u0648";
  let t32;
  if ($[58] !== onSubmitClick || $[59] !== submitLoading || $[60] !== t29 || $[61] !== t30 || $[62] !== t31) {
    t32 = <Button color={t29} fullWidth={true} loading={submitLoading} onClick={onSubmitClick} size={t30}>{t31}</Button>;
    $[58] = onSubmitClick;
    $[59] = submitLoading;
    $[60] = t29;
    $[61] = t30;
    $[62] = t31;
    $[63] = t32;
  } else {
    t32 = $[63];
  }
  let t33;
  if ($[64] !== t28 || $[65] !== t32) {
    t33 = <div className={t28}>{t32}</div>;
    $[64] = t28;
    $[65] = t32;
    $[66] = t33;
  } else {
    t33 = $[66];
  }
  let t34;
  if ($[67] !== hasButtonClose || $[68] !== isFloatCloseButton || $[69] !== landingSearch || $[70] !== onClose || $[71] !== searchType) {
    t34 = landingSearch ? null : hasButtonClose && <div className={`absolute left-0 mr-auto hidden text-center lg:block ltr:ml-auto ${searchType === "hotel" ? "xl:mt-0" : ""} ${isFloatCloseButton && "-top-10"}`}><Button StartIcon={<MaterialIcon name="close" />} color="neutral" onClick={onClose} size="small" variant="text" /></div>;
    $[67] = hasButtonClose;
    $[68] = isFloatCloseButton;
    $[69] = landingSearch;
    $[70] = onClose;
    $[71] = searchType;
    $[72] = t34;
  } else {
    t34 = $[72];
  }
  let t35;
  if ($[73] !== t12 || $[74] !== t13 || $[75] !== t27 || $[76] !== t33 || $[77] !== t34) {
    t35 = <div className={t12}>{t13}{t27}{t33}{t34}</div>;
    $[73] = t12;
    $[74] = t13;
    $[75] = t27;
    $[76] = t33;
    $[77] = t34;
    $[78] = t35;
  } else {
    t35 = $[78];
  }
  let t36;
  if ($[79] !== t11 || $[80] !== t35) {
    t36 = <div className={t11}>{t35}</div>;
    $[79] = t11;
    $[80] = t35;
    $[81] = t36;
  } else {
    t36 = $[81];
  }
  let t37;
  if ($[82] !== t10 || $[83] !== t36 || $[84] !== t9) {
    t37 = <div className={t9}>{t10}{t36}</div>;
    $[82] = t10;
    $[83] = t36;
    $[84] = t9;
    $[85] = t37;
  } else {
    t37 = $[85];
  }
  return t37;
};